import React from "react";
import Shifts from "screens/Shifts/index";
const CancelledShifts = () => {
  return <Shifts status="cancelled" />;
};

export default CancelledShifts;
